import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, forwardRef, inject, input, InputSignal } from '@angular/core';
import { ReactiveFormsModule, NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormField } from 'src/app/pages/register-user/shared/form/abstracts/base-form-field';
import { TimeFieldService } from './services/time-field.service';
import { RegisterUserFormService } from 'src/app/pages/register-user/services';
import { MAX_TIME, MIN_TIME } from './config/constants';

@Component({
  selector: 'app-time-field',
  standalone: true,
  imports: [
    TranslateModule, 
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: forwardRef(() => TimeFieldComponent),
    },
  ],
  templateUrl: './time-field.component.html',
  styleUrls: ['./time-field.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeFieldComponent extends BaseFormField<string | null> {
  // INPUTS
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  public formControlName: InputSignal<string | null> = input<string | null>(null);
  
  // SERVICE INJECTIONS
  private _timeFieldService = inject(TimeFieldService);
  private _registerUserFormService = inject(RegisterUserFormService);
  
  // SERVICE STATE SIGNALS
  protected startTime = this._registerUserFormService.startTime;
  protected endTime = this._registerUserFormService.endTime;
  
  // CONSTANTS
  protected maxTime = MAX_TIME;
  protected minTime = MIN_TIME;

  // METHODS
  /**
   * Gets the current value for this time field
   * @returns The current time value or empty string
   */
  protected getCurrentValue(): string {
    return this._timeFieldService.getCurrentTimeValue(this.formControlName());
  }
  
  /**
   * Gets the appropriate label for this time field
   * @returns The localized label text
   */
  protected getLabel(): string {
    return this._timeFieldService.getFieldLabel(this.formControlName());
  }
  
  /**
   * Determines if this is the start time field
   * @returns True if this is the start time field
   */
  protected isStartTime(): boolean {
    return this._timeFieldService.isStartTimeField(this.formControlName());
  }
  
  /**
   * Handles input events from the time field
   * Updates both the form control value and the service state
   * @param event - The input event from the time field
   */
  protected handleInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const inputValue = target.value;
    
    // if (!inputValue) {
    //   console.warn(`Invalid time value: ${inputValue} for field: ${this.formControlName()}`);
    //   return;
    // }
    
    this.value = inputValue;
    this.onChange(inputValue);
    
    this._timeFieldService.updateTimeValue(this.formControlName(), inputValue);
  }
}
